import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import CircularProgress from '@material-ui/core/CircularProgress';
import KFormField from "../components/onboarding/kFormField";
import { Grid } from '@material-ui/core';
import KDialog from "../components/kdialog";
import misc from "../utils/misc";

import KCard from "../components/kCard";

import api from "../api";

const requiredValidator = value => value ? true : false;
const emailValidator = value =>
  value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
const errorMsgAllFiledsRequired = 'Please fill all fields.';

const validatedFields = [
  { id: 'email', msg: 'Invalid email address', validator: emailValidator },
  { id: 'pin', msg: 'Pin required', validator: requiredValidator }
];

/*
  let self = this;
  this.props.context.getPeople() 
    .then(json => { self.setState({rows:json.rows, loaded: true}); })  
}
*/



export default class StepLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.getStore().user.email,
      pin: props.getStore().user.pin,
      //cid : props.getStore().cid,
      userMsg: '',

      showAlert: false,
      alertMessages: [],
      alertTitle: ''
    };
    this._validateOnDemand = true;
    this.isValidated = this.isValidated.bind(this);
    this.onInputValueChanged = this.onInputValueChanged.bind(this);
    this.onValueRequiredValidate = this.onValueRequiredValidate.bind(this);
    this.onAlertClose = this.onAlertClose.bind(this);
  }
  /*
    componentDidMount(){
      let sd = window.SERVER_DATA;
      alert(JSON.stringify(sd));
    }*/

  isValidated() {
    let isDataValid = false;
    const userInput = this._grabUserInput();
    const validateNewInput = this._validateData(userInput);
    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k].valid === true })) {
      // local validation done
      // now server validate.
      return this.serverValidate(userInput);
    }
    let alertMessages = [];
    alertMessages.push(errorMsgAllFiledsRequired)
    this.setState((state, props) => {
      return { showAlert: true, alertMessages: alertMessages };
    });

    return isDataValid;
  }

  alertDlg = () => (
    this.state.showAlert ? <KDialog onAlertClose={this.onAlertClose} showAlert={true} messages={this.state.alertMessages} /> : ''
  )

  onAlertClose() {
    this.setState((state, props) => {
      return { showAlert: false };
    });
  }

 

  async serverValidate(userInput) {
    this.setState({ busy: true, userMsg: '' });
    userInput.cid = this.props.getStore().center.id;
    let data = await api.user.begin(userInput);
    if (data.success === true) {      
      data.user.promotions.expires = misc.dateHelper.parseDate(data.user.promotions.expires);
      let user = Object.assign({}, this.props.getStore().user,
        {
          email: userInput.email, pin: userInput.pin, token: data.token, parentName: data.user.parentName,
          students: data.user.students, apiKey: data.apiKey, startDate: data.user.startDate,
          options: data.user.options,
          promotions : data.user.promotions,
          promoNA : false,
          splitPayment: data.user.splitPayment,         
          notesForParent: data.user.notesForParent
        });
      data.center.terms.forEach(t => t.checked = false);

      let stData = { center: data.center, user: user }
      
      if(data.nextAction) {        
        stData.nextAction = data.nextAction;
      } 

      this.props.updateStore({
        ...stData,
        savedToCloud: false
      });
    }
    this.setState({ busy: false, userMsg: data.message });
    return data.success;
  }

  _grabUserInput() {
    return {
      email: this.state.email,
      pin: this.state.pin
    };
  }

  _validateData(data) {
    let result = {};
    var _this = this;
    validatedFields.forEach(function (val, index) {
      // let a = _this.validateOne(data, val.id);
      let a = _this.onValueRequiredValidate(val.id, data[val.id], true);
      result = Object.assign(result, { [val.id]: a });
    })
    return result;
  }

  onInputValueChanged = (id, value) => {
    this.setState({ [id]: value });
  }


  onValueRequiredValidate = (id, value, updateState) => {
    //console.log(`onValueRequiredValidate for ${id}, ${value}`)
    var fld = validatedFields.find(o => o.id === id);
    let valid = fld.validator(value); //(value !== "");

    if (valid === '') // email validator returns empty string, when value is '' 
      valid = false;

    //let attrib = id + 'ValMsg';
    let attrib = 'message';

    let msg = '';
    if (!valid)
      msg = validatedFields.find(o => o.id === id).msg;

    if (updateState) {
      this.setState((state, props) => {
        return { [attrib]: msg };
      });
    }
    let ret = { valid, [attrib]: msg };
    //console.log(JSON.stringify(ret));
    return ret;
  }
  /*
    loading = () => (
      this.state.busy ? <Spinner animation="border" variant="primary" role="status"><span className="sr-only">Loading...</span></Spinner> : ''
    )
  */

  loading = () => (
    this.state.busy ? <CircularProgress /> : ''
  )
  userMessage = () => (
    this.state.userMsg === '' ? '' : <div className="alert alert-warning">{this.state.userMsg}</div>
  )

  render() {
    return (
      <div className="step step1">
          <KCard>
        <form id="Form" className="form-horizontal">
          <div className="form-group row">
            <label className="col-md-12 control-label">
            <Typography                
              variant='h5'>
              Get Started
            </Typography>
            </label>
          </div>
          <div className="your-class mt-3 lead">
            <Typography                
                  variant='subtitle1'>
            Enter your Email and Pin you received.
            </Typography>
            </div>
          <div className="your-class mt-3"></div>

          <Box m="auto">
          <Grid container spacing={3}>
            <Grid item xs={12} >
              <KFormField id="email"
                onChange={this.onInputValueChanged}
                validator={this.onValueRequiredValidate}
                zoom='full'
                label='Email'
                type='email'                
                value={this.state.email}
                placeholder="Email"
                autoFocus
                errorMsg={this.state.emailValMsg}></KFormField>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} >
              <KFormField id="pin"
                onChange={this.onInputValueChanged}
                validator={this.onValueRequiredValidate}
                zoom='full'
                label='Pin'                
                value={this.state.pin}
                placeholder="pin"
                errorMsg={this.state.pinValMsg}></KFormField>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} >
              {this.loading()}
              {this.userMessage()}
            </Grid>
          </Grid>

          </Box>

         
          <div className="your-class mt-3"></div>
        </form>
        </KCard>
        {this.alertDlg()}
      </div>
    )
  }
}
